import { Drawer, FAIcon, IconStyle } from '@nextgen-web-framework/all';
import { SocialShareLink } from '../SocialShareLink/SocialShareLink';
import type { SharebarDrawerProps } from './types/propTypes';
import styles from './SharebarDrawer.module.scss';

const SharebarDrawer = ({ onClose, shareTitle, accountType, shareDesc, backBtn, fullUrl }: SharebarDrawerProps) => {
  const configs = ConfigService.getConfigs();
  const environment = configs.NEXT_SSR_BASE_PATH;
  return (
    <div data-testid="sharebar-wrapper-test-id">
      <Drawer
        header={
          <div className={styles['drawer-container']}>
            {backBtn ? (
              <div className={styles['back-icon-container']} data-testid="sharebar-back-button-test-id">
                <FAIcon iconName={'angle-left'} iconStyle={IconStyle.SOLID} onClick={onClose} />
              </div>
            ) : (
              ''
            )}
            <div className={styles['sharebar-title']}>{shareTitle}</div>{' '}
          </div>
        }
        closeIcon={!backBtn}
        closeOnBackdropClick={true}
        bottomGap={0}
        onClose={onClose}
        useReactPortal={true}
        portalContainerId={'react-portal-drawer'}
      >
        <div className={styles['sharebar-drawer-container']} data-testid="sharebar-drawer-test-id">
          <SocialShareLink
            linkProps={{
              category: 'mepanel',
              data: '',
              fullUrl: fullUrl,
              title: shareTitle,
              registrationAccountType: accountType,
            }}
            shareDrawer={true}
            isCustomUrl={environment === 'global-dev'}
            shareDescriptionsContent={shareDesc}
          />
        </div>
      </Drawer>
    </div>
  );
};

export default SharebarDrawer;
